import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Carousel.module.css';
import { IconChevronLeft16, IconChevronRight16 } from '../../../icons';
import { useCarouselButtons } from './hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Carousel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children;
  var scrollableContainerRef = React.useRef(null);
  var _useCarouselButtons = useCarouselButtons({
      scrollableContainerRef: scrollableContainerRef,
      tabsRef: ref
    }),
    showLeftCarouselButton = _useCarouselButtons.showLeftCarouselButton,
    showRightCarouselButton = _useCarouselButtons.showRightCarouselButton,
    onLeftCarouselButtonClick = _useCarouselButtons.onLeftCarouselButtonClick,
    onRightCarouselButtonClick = _useCarouselButtons.onRightCarouselButtonClick;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("button", {
      className: clsx(styles['chevron-button'], styles['chevron-button--left'], _defineProperty({}, styles['chevron-button--visible'], showLeftCarouselButton)),
      onClick: onLeftCarouselButtonClick,
      children: /*#__PURE__*/_jsx(IconChevronLeft16, {})
    }), /*#__PURE__*/_jsx("div", {
      className: styles['scrollable-container'],
      ref: scrollableContainerRef,
      children: children
    }), /*#__PURE__*/_jsx("button", {
      className: clsx(styles['chevron-button'], styles['chevron-button--right'], _defineProperty({}, styles['chevron-button--visible'], showRightCarouselButton)),
      onClick: onRightCarouselButtonClick,
      children: /*#__PURE__*/_jsx(IconChevronRight16, {})
    })]
  });
});
Carousel.displayName = 'Carousel';